
$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

$(document).on("click", "a[href='#']:not(.custom_section_2 .richtext_blocks_new.left a[href='#'])", function (e) {
  e.preventDefault();
  document.querySelector('#collection').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", ".custom_section_2 .richtext_blocks_new.left a[href='#']", function (e) {
  e.preventDefault();
});
$(document).on("click", "a[href='#science']", function (e) {
  e.preventDefault();
  document.querySelector('#science').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#results']", function (e) {
  e.preventDefault();
  document.querySelector('#results').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#formula']", function (e) {
  e.preventDefault();
  document.querySelector('#formula').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", ".sidebar_text a", function (e) {
$('.sidebar_text a').removeClass('active');
$(this).addClass('active');
});



 document.addEventListener('scroll', () => {
    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return(rect.top >= 0 && rect.left >= 0 && rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    }

    if ( ! isInViewport(document.querySelector('.custom_section_2 .richtext_blocks_new.left'))) {
      document.querySelector('.custom_section_2 .lp_right_sidebar').classList.add("sticky_button");
    } else {
      document.querySelector('.custom_section_2 .lp_right_sidebar').classList.remove("sticky_button");
    }
  });